import React, { useContext, useEffect, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import { useHistory } from "react-router";
import {
  wsGetVerificaEstudios,
  wsPostTurnosEstudios,
  logoutEstudiosTurnos,
} from "../../../context/Actions/turnos/estudioTurnos";
import {
  logoutConsultaMedTurnos,
  wsGetVerificaConsultaMedica,
  wsPostConsultaMedTurnos,
} from "../../../context/Actions/turnos/consultaMedTurnos";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import { showModal, hideModal } from "../../../context/Actions/modal/modal";
import {
  editaTurnosDisponibles,
  editaTurnosDisponiblesPush,
  setFechaTurno,
} from "../../../context/Actions/turnos/turnosDisponibles";
import { IonSpinner } from "@ionic/react";
import fechaTurnoFormat from "../../../../global/utils/fechaTurnoFormat";
import Dropdown from "../../Genericos/Dropdown/Dropdown";
import DatePicker from "../../Genericos/DatePicker/DatePicker";
import "./BuscadorConsultaMedica.css";
import { dropdownFamiliares } from "../ListaFamiliaresDropdown/ListaFamiliaresDropdown";
import { GlobalContext } from "../../../../global/context/Provider";
import InputV1 from "../../Genericos/InputV1/InputV1";
import PresentismoBox from "../PresentismoBox/PresentismoBox";
import {
  resetPresentismo,
  wsGetPresentismoDetalle,
} from "_+_Portal/context/Actions/presentismo/presentismo";
import DropdownV2 from "_+_Portal/components/Genericos/DropdownV2/DropdownV2";

const BuscadorConsultaMedica2 = ({
  onChangeMultitabMobile,
  buscadorTurnos,
  itemBusqueda,
  busquedaAuto,
}) => {
  const history = useHistory();

  const {
    estudioGrupoState,
    estudioTurnosDispatch,
    estudioTurnosState,
    modalDispatch,
    consultaMedTurnosDispatch,
    consultaMedTurnosState,
    turnosDisponiblesDispatch,
    turnosDisponiblesState,
    listaFamiliaresState,
    selectDropDownState,
    textosState,
    presentismoDispatch,
    presentismoState,
  } = useContext(PortalContext);

  // Cambio de contexto
  const { authState, toasterDispatch, configState } = useContext(GlobalContext);

  // Información para el date picker
  const fechaLimte = new Date();
  const days = 90;
  fechaLimte.setDate(fechaLimte.getDate() + days);

  const [onChangeVc, setOnChangeVc] = useState(false);
  const [onChangePres, setOnChangePres] = useState(true);
  const [idEstudio, setIdEstudio] = useState("");
  const [descEstudio, setDescEstudio] = useState("");
  const [especialidad, setEspecialidad] = useState("");
  const [medico, setMedico] = useState("");
  const [descEspecialidad, setDescEspecialidad] = useState("");
  const [fecha, setFecha] = useState();
  const [flgEstudioParticular, setFlgEstudioParticular] = useState(false);
  const [flgEspecialidadPart, setFlgEspecialidadPart] = useState(false);
  const [flgEspecialidadOk, setFlgEspecialidadOk] = useState(false);
  const [flgEstudioOk, setFlgEstudioOk] = useState(false);
  const [flgModal, setFlgModal] = useState(false);
  const [flgPushTurnosDisp, setFlgPushTurnosDisp] = useState(false);
  const [determinaciones, setDeterminaciones] = useState();
  const [dtoBusqEstudioDefault, setDtoBusqEstudioDefault] = useState();
  const [flgDobleVerif, setDobleVerif] = useState(false);
  const [errorDropdown, setErrorDropdown] = useState(false);
  const [pacienteSeleccionado, setPacienteSeleccionado] = useState();
  const [user, setUser] = useState(authState);
  const [OSAlternativa, setOSAlternativa] = useState(false);
  let dtoPOST = false;

  let config = localStorage.getItem("config");
  let portalCem = JSON.parse(config).portal;
  let bloqueoPresentismo = JSON.parse(config).opcBloqueoPresentismo;
  let accion = sessionStorage.getItem("accionHash");

  useEffect(() => {
    if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      // es el paciente completo
      setUser({
        auth: {
          data: selectDropDownState.selectDropDown.selectGlobal.pacienteElegido,
        },
      });
    } else {
      setUser(authState);
    }
  }, [selectDropDownState.selectDropDown.selectGlobal.pacienteElegido]);

  const dissmiss = () => {
    hideModal()(modalDispatch);
    resetPresentismo()(presentismoDispatch);
  };

  const onChangeDatePicker = (e) => {
    setFecha(e);
    setFechaTurno(e)(turnosDisponiblesDispatch);
  };

  // Nuevo useEffect para el nuevo buscador, cuando presiono en uno de los
  // mas buscados hago la busqueda del turno directamente
  useEffect(() => {
    if (itemBusqueda !== null && itemBusqueda !== undefined) {
      onChangeBuscador(itemBusqueda);
      setFecha(fechaTurnoFormat());
    }
  }, [itemBusqueda]);

  // Este solo se ejecuta en caso de estar en la app, y seleccionar uno de los turnos
  // mas buscados, la busqueda se iniciara automaticamente
  useEffect(() => {
    if (
      itemBusqueda !== null &&
      itemBusqueda !== undefined &&
      busquedaAuto &&
      (flgEspecialidadOk || flgEstudioOk)
    ) {
      onBuscarTurnosClick(itemBusqueda);
    }
  }, [itemBusqueda, flgEspecialidadOk, flgEstudioOk]);

  const onChangeBuscador = (e) => {
    setFlgEstudioOk(false);
    setFlgEspecialidadOk(false);
    setFlgModal(false);
    setPacienteSeleccionado(e);
    if (e !== "") {
      if (
        (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
          ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
              .paciente.ausentismo.rankingConsultas === "Rojo"
          : authState.auth.data.paciente.ausentismo.rankingConsultas ===
            "Rojo") &&
        (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
          ? !selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
              .paciente.seguimiento
          : !authState.auth.data.paciente.seguimiento) &&
        bloqueoPresentismo === true
      ) {
        showModal(
          "Genericos/Mensaje/Mensaje",
          {
            titulo: <span className="rb24b">Atención</span>,
            textoNegrita: (
              <span className="rb18l">
                {textosState?.textos?.data?.msjBloqueoAusentismo?.descripcion}
              </span>
            ),
            dissmiss: dissmiss,
          },
          [
            {
              text: "Cerrar",
              clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
              accion: dissmiss,
            },
          ],
          "centro",
          true
        )(modalDispatch);
      } else {
        setFlgEstudioParticular(false);
        setFlgEspecialidadPart(false);
        setFlgModal(false);
        setErrorDropdown(false);
        if (e.id !== null && e.id !== undefined && e.id < 0) {
          setEspecialidad(e.especialidad);
          setMedico(e.medico);
          setDescEspecialidad(e.descripcion);
          setIdEstudio("");
          setDescEstudio("");
          // verifica si el paciente tiene esa obra social
          if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
            wsGetVerificaConsultaMedica(
              e.especialidad,
              e.medico,
              selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                .id,
              false,
              verificarConsulta
            )(consultaMedTurnosDispatch);
          } else {
            wsGetVerificaConsultaMedica(
              e.especialidad,
              e.medico,
              -1,
              false,
              verificarConsulta
            )(consultaMedTurnosDispatch);
          }
        } else if (e.id !== null && e.id !== undefined && e.id > 0) {
          setMedico("");
          setEspecialidad("");
          setDescEspecialidad("");
          setIdEstudio(e.id);
          setDescEstudio(e.descripcion);
          // Prestación nueva: siempre se verifica con la cobertura (particular=false),
          // no con el valor viejo del closure de flgEstudioParticular.
          if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
            wsGetVerificaEstudios(
              e.id,
              false,
              onChangeVc,
              selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                .id,
              false,
              verificarEstudio
            )(estudioTurnosDispatch);
          } else {
            wsGetVerificaEstudios(
              e.id,
              false,
              onChangeVc,
              -1,
              false,
              verificarEstudio
            )(estudioTurnosDispatch);
          }
        }
      }
      setErrorDropdown(false);
    } else {
      setFlgEstudioParticular(false);
      setFlgEspecialidadPart(false);
      setFlgModal(false);
      setEspecialidad("");
      setMedico("");
      setDescEspecialidad("");
      setIdEstudio("");
      setDescEstudio("");
    }
  };

  const verificarConsulta = (isCorrect, data) => {
    if (isCorrect) {
      if (data.continua && data.circuito === null && data.codigo === 0) {
        setFlgEspecialidadOk(true);
        setFlgEstudioOk(false);
        logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
      } else if (
        !data.continua &&
        data.circuito === null &&
        data.codigo !== 9 &&
        data.codigo !== 91
      ) {
        showToaster(
          {
            texto: data.mensaje,
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
        setFlgEspecialidadOk(false);
        logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
      } else if (
        !data.continua &&
        data.circuito === null &&
        data.codigo === 9
      ) {
        setFlgEspecialidadPart(true);
        setFlgEspecialidadOk(true);
        setFlgModal(true);
        setFlgEstudioOk(false);
        modalParticular();
        logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
      } else if (
        !data.continua &&
        data.circuito === null &&
        data.codigo === 91
      ) {
        setOSAlternativa(true);
        setFlgEspecialidadOk(true);
        setFlgModal(true);
        setFlgEstudioOk(false);
        modalOSAlternativa();
        logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
      }
    }
  };

  const verificarEstudio = (isCorrect, data) => {
    if (isCorrect) {
      if (data.continua && data.circuito === "") {
        setFlgEstudioOk(true);
        setFlgEspecialidadOk(false);
        logoutEstudiosTurnos()(estudioTurnosDispatch);
      } else if (
        data.turnos !== null &&
        data.turnos !== undefined &&
        data.turnos !== ""
      ) {
        editaTurnosDisponibles({
          ...turnosDisponiblesState.turnosDisponibles.turnosData,
          turnos: data.turnos,
          GruposMedico: [
            {
              Id: idEstudio,
              Descripcion: descEstudio,
              Particular: flgEstudioParticular,
            },
          ],
          particular: flgEstudioParticular,
          idEstudio: idEstudio,
          descEstudio: descEstudio,
          descEspecialidad: null,
          fechaBusqueda: data.fechaBusqueda,
          dtoBusqueda: dtoPOST,
          volverOrigen: "CONSULTA_MEDICA",
          proceso: "estudios",
        })(turnosDisponiblesDispatch);
        setFlgEstudioParticular(false);
        setFlgPushTurnosDisp(true);
      } else if (data.codigo === 9) {
        setFlgEstudioParticular(true);
        setFlgEstudioOk(true);
        setFlgModal(true);
        setFlgEspecialidadOk(false);
        modalParticular();
        logoutEstudiosTurnos()(estudioTurnosDispatch);
      } else if (data.codigo === 8) {
        showModal(
          "Genericos/Mensaje/Mensaje",
          {
            titulo: "Atención",
            texto: (
              <div
                dangerouslySetInnerHTML={{
                  __html: data.mensaje,
                }}
              ></div>
            ),
            dissmiss: dissmiss,
            danger: true,
          },
          [
            {
              text: "Volver",
              clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
              accion: cancelaParticular,
            },
          ],
          "centro"
        )(modalDispatch);
        setFlgEspecialidadOk(false);
        logoutEstudiosTurnos()(estudioTurnosDispatch);
      } else if (data.codigo === 91) {
        setOSAlternativa(true);
        setFlgEstudioOk(true);
        setFlgModal(true);
        setFlgEspecialidadOk(false);
        modalOSAlternativa();
        logoutEstudiosTurnos()(estudioTurnosDispatch);
      } else if (data.codigo === 10) {
        modalAtencionSinTurnoPrevio();
        logoutEstudiosTurnos()(estudioTurnosDispatch);
      } else if (data.codigo) {
        showToaster(
          {
            texto: data.mensaje,
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
        logoutEstudiosTurnos()(estudioTurnosDispatch);
      } else {
        showToaster(
          {
            texto: "Ha ocurrido un error",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
        logoutEstudiosTurnos()(estudioTurnosDispatch);
      }
    }
  };

  const verTurnosDisponibles = (isCorrect, data) => {
    if (isCorrect) {
      if (data.data.length >= 0) {
        editaTurnosDisponibles({
          ...turnosDisponiblesState.turnosDisponibles.turnosData,
          turnos: data.data,
          grupoMedico: null,
          particular: flgEspecialidadPart,
          idEstudio: null,
          descEstudio: null,
          descEspecialidad: descEspecialidad,
          fechaBusqueda: data.fechaBusqueda,
          dtoBusqueda: dtoPOST,
          volverOrigen: "CONSULTA_MEDICA",
          proceso: "consMedica",
        })(turnosDisponiblesDispatch);
        setFlgPushTurnosDisp(true);
      }
    }
  };

  // reemplace radio por check por la dificultad de marcar 1 si o no en un check
  const onChangeRadio = (e) => {
    // let usuario = Object.assign({}, registroState.registro.usuario);
    if (e.target.value === "true") {
      setOnChangePres(true);
      setOnChangeVc(false);
      setFlgEstudioParticular(false);
      setDobleVerif(true);
    } else {
      setOnChangePres(false);
      setOnChangeVc(true);
      setFlgEstudioParticular(false);
      setDobleVerif(true);
    }
  };

  useEffect(() => {
    if (
      flgPushTurnosDisp &&
      turnosDisponiblesState?.turnosDisponibles?.turnosData?.turnos
    ) {
      history.push("/turnosDisponibles");
      setFlgPushTurnosDisp(false);
    }
  }, [flgPushTurnosDisp, turnosDisponiblesState.turnosDisponibles.turnosData]);

  useEffect(() => {
    if (flgDobleVerif) {
      if (medico !== "" && especialidad !== "" && descEspecialidad !== "") {
        setIdEstudio("");
        setDescEstudio("");
        setFlgEstudioParticular(false);
        setFlgEspecialidadOk(false);
        // verica si el paciente tiene obra social
        if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
          wsGetVerificaConsultaMedica(
            especialidad,
            medico,
            selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
            false,
            verificarConsulta
          )(consultaMedTurnosDispatch);
        } else {
          wsGetVerificaConsultaMedica(
            especialidad,
            medico,
            -1,
            false,
            verificarConsulta
          )(consultaMedTurnosDispatch);
        }
        setDobleVerif(false);
      } else if (idEstudio !== "" && descEstudio !== "") {
        setMedico("");
        setEspecialidad("");
        setDescEspecialidad("");
        if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
          wsGetVerificaEstudios(
            idEstudio,
            flgEstudioParticular,
            onChangeVc,
            selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
            false,
            verificarEstudio
          )(estudioTurnosDispatch);
        } else {
          wsGetVerificaEstudios(
            idEstudio,
            flgEstudioParticular,
            onChangeVc,
            -1,
            false,
            verificarEstudio
          )(estudioTurnosDispatch);
        }
        setDobleVerif(false);
      }
    }
  }, [flgDobleVerif]);

  const onBuscarTurnosClick = (pacienteSeleccionado) => {
    if (
      (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
        ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
            .paciente.ausentismo.rankingConsultas === "Rojo"
        : authState.auth.data.paciente.ausentismo.rankingConsultas ===
          "Rojo") &&
      (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
        ? !selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
            .paciente.seguimiento
        : !authState.auth.data.paciente.seguimiento) &&
      bloqueoPresentismo === true
    ) {
      showModal(
        "Genericos/Mensaje/Mensaje",
        {
          titulo: <span className="rb24b">Atención</span>,
          textoNegrita: (
            <span className="rb18l">
              {textosState?.textos?.data?.msjBloqueoAusentismo?.descripcion}
            </span>
          ),
          dissmiss: dissmiss,
        },
        [
          {
            text: "Cerrar",
            clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
            accion: dissmiss,
          },
        ],
        "centro",
        true
      )(modalDispatch);
    } else {
      // CAMBIE EL IF QUE NO DEJABA BUSCAR POR ESPECIALIDAD, YA ARROJA ERROR SI EL CAMPO ESTA VACIO
      if (pacienteSeleccionado !== "" && pacienteSeleccionado !== undefined) {
        if (!flgModal) {
          // funcion para obtener la fecha formateada en caso de necesitarla para la busqueda
          if (flgEspecialidadOk) {
            dtoPOST = {
              especialidad: especialidad,
              medico: medico,
              fecha: fecha,
              flgEspecialidadPart: flgEspecialidadPart,
              videoConsulta: onChangeVc,
              videoAtencion: onChangeVc,
              OsAlternativa: OSAlternativa ? OSAlternativa : false,
            };
            if (
              selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
            ) {
              wsPostConsultaMedTurnos(
                especialidad,
                medico,
                fecha,
                flgEspecialidadPart,
                onChangeVc,
                selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                  .id,
                false,
                verTurnosDisponibles
              )(consultaMedTurnosDispatch);
            } else {
              wsPostConsultaMedTurnos(
                especialidad,
                medico,
                fecha,
                flgEspecialidadPart,
                onChangeVc,
                -1,
                OSAlternativa ? OSAlternativa : false,
                verTurnosDisponibles
              )(consultaMedTurnosDispatch);
            }
            setFlgEspecialidadOk(false);
          } else if (flgEstudioOk) {
            let dtoEstBusqueda = {
              ...dtoBusqEstudioDefault,
              amamantando: false,
              conContraste: false, ////lo obtengo de seleccionar el item especialidad o estudio
              contrasteReciente: false,
              diabeticoHipertenso: false,
              embarazada: false,
              fechaDesde: fecha, //fecha esta en datepicker,
              GruposMedico: [
                {
                  Id: idEstudio,
                  Descripcion: descEstudio,
                  Particular: flgEstudioParticular,
                },
              ],
              idGrupoMedico: idEstudio, //lo obtengo de seleccionar el item especialidad o estudio
              idObraSocial: selectDropDownState.selectDropDown.selectGlobal
                .pacienteElegido
                ? selectDropDownState.selectDropDown.selectGlobal
                    .pacienteElegido.paciente.obra_social
                : user.auth.data.paciente.obra_social,
              idPlan: selectDropDownState.selectDropDown.selectGlobal
                .pacienteElegido
                ? selectDropDownState.selectDropDown.selectGlobal
                    .pacienteElegido.paciente.idplan
                : user.auth.data.paciente.idplan,
              insRenal: false,
              marcapasos: false,
              operador: accion ? "BOT" : "",
              pag: 1200, //hardcodeado en angular
              particular: flgEstudioParticular, //lo obtengo de seleccionar el check
              pesoSuperior: false,
              pesoSuperiorCritico: false,
              rec: 0, //harcodeado en angularionic
              videoAtencion: onChangeVc, //lo lleno por con el checkbox
              OsAlternativa: OSAlternativa ? OSAlternativa : false,
            };
            setDtoBusqEstudioDefault(dtoEstBusqueda);
            let objBusqueda = verificaCambioFecha(dtoEstBusqueda);
            dtoPOST = objBusqueda;
            if (
              selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
            ) {
              wsPostTurnosEstudios(
                objBusqueda,
                selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                  .id,
                verificarEstudio
              )(estudioTurnosDispatch);
            } else {
              wsPostTurnosEstudios(
                objBusqueda,
                -1,
                verificarEstudio
              )(estudioTurnosDispatch);
            }
            setDtoBusqEstudioDefault(undefined);
          }
        } else {
          // le consulto nuevamente si lo quiere tomar como part.
          if (flgEspecialidadOk) {
            if (
              selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
            ) {
              wsGetVerificaConsultaMedica(
                especialidad,
                medico,
                selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                  .id,
                false,
                verificarConsulta
              )(consultaMedTurnosDispatch);
            } else {
              wsGetVerificaConsultaMedica(
                especialidad,
                medico,
                -1,
                false,
                verificarConsulta
              )(consultaMedTurnosDispatch);
            }
          } else if (flgEstudioOk) {
            // Re-verificación con la cobertura y con el formato elegido (video o presencial).
            if (
              selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
            ) {
              wsGetVerificaEstudios(
                idEstudio,
                false,
                onChangeVc,
                selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                  .id,
                false,
                verificarEstudio
              )(estudioTurnosDispatch);
            } else {
              wsGetVerificaEstudios(
                idEstudio,
                false,
                onChangeVc,
                -1,
                false,
                verificarEstudio
              )(estudioTurnosDispatch);
            }
          }
        }
      } else {
        setErrorDropdown(true);
      }
    }
  };

  //agrego lo de cambio de fecha en consulta medica.
  const verificaCambioFecha = (dto) => {
    let objBusqDefault = Object.assign({}, dto);
    if (fecha !== null) {
      objBusqDefault.fechaDesde = fecha;
    } else if (
      turnosDisponiblesState.turnosDisponibles.turnosData.fechaSeleccionada
    ) {
      objBusqDefault.fechaDesde =
        turnosDisponiblesState.turnosDisponibles.turnosData.fechaSeleccionada;
    }
    return objBusqDefault;
  };

  const cancelaParticular = () => {
    dissmiss();
    logoutEstudiosTurnos()(estudioTurnosDispatch);
    logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
    setFlgEspecialidadPart(false);
    setFlgEstudioParticular(false);
    setFlgModal(false);
  };

  const cancelaAlternativa = () => {
    dissmiss();
    logoutEstudiosTurnos()(estudioTurnosDispatch);
    logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
    setOSAlternativa(false);
    setFlgEstudioOk(false);
    setFlgEspecialidadOk(false);
    setFlgModal(false);
  };

  const deterComoParticular = () => {
    dissmiss();
    setFlgModal(false);
    logoutEstudiosTurnos()(estudioTurnosDispatch);
    logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
  };

  const modalParticular = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "La obra social no cubre el estudio",
        textoNegrita: "¿Deseás tomar el turno como particular?",
        texto: "La determinacion seleccionada no figura dentro de tu cobertura",
        // La cruz equivale a "Cancelar" (si solo cerrara, flgEstudioParticular quedaba en true).
        dissmiss: cancelaParticular,
      },
      [
        {
          text: "Cancelar",
          clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
          accion: cancelaParticular,
        },
        {
          text: "Tomar como particular",
          clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
          accion: deterComoParticular,
        },
      ],
      "centro",
      true // bloquearDissmiss: el fondo no cierra sin pasar por un botón
    )(modalDispatch);
  };

  const modalOSAlternativa = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "La obra social no cubre el estudio",
        textoNegrita: "¿Deseás tomar el turno con tu obra social alternativa?",
        texto: "La determinacion seleccionada no figura dentro de tu cobertura",
        dissmiss: cancelaAlternativa,
      },
      [
        {
          text: "Cancelar",
          clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
          accion: cancelaAlternativa,
        },
        {
          text: "Tomar con OS alternativa",
          clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
          accion: deterComoParticular,
        },
      ],
      "centro",
      true
    )(modalDispatch);
  };

  const modalAtencionSinTurnoPrevio = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "El estudio se realiza sin turno previo",
        textoNegrita: "Prueba",
        texto: "a Definir",
        dissmiss: dissmiss,
        danger: true,
      },
      [
        {
          text: "Salir",
          clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
          accion: dissmiss,
        },
        {
          text: "Leer sobre turnos sin reserva",
          clase: "btn-Mensaje-1 rb16m bgc-latex30 c-white",
          accion: dissmiss,
        },
      ],
      "centro"
    )(modalDispatch);
  };

  //agrego logica volver a verificar estudio/consMed por cambio de paciente.
  useEffect(() => {
    if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      setFlgEstudioParticular(false);
      setFlgEspecialidadPart(false);
      setFlgModal(false);
      // deberia preguntar primero si busque algo. aca usamos idestudio.
      if (especialidad !== "" && medico) {
        wsGetVerificaConsultaMedica(
          especialidad,
          medico,
          selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
          false,
          verificarConsulta
        )(consultaMedTurnosDispatch);
      } else if (idEstudio !== "" && descEstudio !== "") {
        // Cambio de paciente: se verifica con la cobertura, no con el flag viejo del closure.
        wsGetVerificaEstudios(
          idEstudio,
          false,
          onChangeVc,
          selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
          false,
          verificarEstudio
        )(estudioTurnosDispatch);
      }
    } else {
      if (
        (especialidad !== "" && medico !== "") ||
        (idEstudio !== "" && descEstudio !== "")
      ) {
        setFlgEstudioParticular(false);
        setFlgEspecialidadPart(false);
        setFlgModal(false);
        if (especialidad !== "" && medico !== "") {
          wsGetVerificaConsultaMedica(
            especialidad,
            medico,
            -1,
            false,
            verificarConsulta
          )(consultaMedTurnosDispatch);
        } else if (idEstudio !== "" && descEstudio !== "") {
          wsGetVerificaEstudios(
            idEstudio,
            false,
            onChangeVc,
            -1,
            false,
            verificarEstudio
          )(estudioTurnosDispatch);
        }
      }
    }
  }, [selectDropDownState.selectDropDown.selectGlobal]);

  useEffect(() => {
    if (estudioGrupoState.estudioGrupo.data !== null) {
      const arrGrupoMed = estudioGrupoState.estudioGrupo.data.filter(
        (item) =>
          item.sonPracticas === false &&
          item.idCircuito !== "RMN" &&
          item.idCircuito !== "TOMO"
      );
      const grupoMed = arrGrupoMed.filter((item) => item.id > 0);
      const agenda = arrGrupoMed.filter((item) => item.id < 0);
      const turnosCompletos = grupoMed.concat(agenda);
      let filt = turnosCompletos.sort((a, b) => {
        return b.cantBusquedas - a.cantBusquedas;
      });
      setDeterminaciones(filt);
      setFecha(fechaTurnoFormat());
    }
    //me aseguro que siempre se limpien los turnos disponibles
    // finalizaTurnosDisponibles()(turnosDisponiblesDispatch);
  }, []);

  // Busca el dia de hoy para el datePicker
  const hoyDia = new Date();
  const noventaDiasDespues = new Date();
  noventaDiasDespues.setDate(noventaDiasDespues.getDate() + 90);

  const modalTurnosPresentismo = () => {
    if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      wsGetPresentismoDetalle(
        true,
        selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id
      )(presentismoDispatch);
    } else {
      wsGetPresentismoDetalle(true, false)(presentismoDispatch);
    }
  };

  useEffect(() => {
    if (presentismoState.presentismo.data !== null) {
      showModal(
        "Turnos/ModalPresentismo/ModalPresentismo",
        {
          dissmiss: dissmiss,
          danger: true,
        },
        [],
        "centro",
        true
      )(modalDispatch);
    }
  }, [presentismoState.presentismo.data]);

  const modalInfoPresentismo = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: <span className="rb24b">Información</span>,
        textoNegrita: (
          <span
            className="rb18l explicacionPresentismo"
            dangerouslySetInnerHTML={{
              __html:
                textosState?.textos?.data?.msjPresentismoAyuda?.descripcion,
            }}
          ></span>
        ),
        dissmiss: dissmiss,
      },
      [
        {
          text: "Aceptar",
          clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
          accion: dissmiss,
        },
      ],
      "centro",
      true
    )(modalDispatch);
  };

  const configDropdown = {
    data: determinaciones,
    ordenPersonalizado: true,
    autoFocus: true,
    header: buscadorTurnos ? "" : "Busca por especialidad o profesional",
    headerColor: buscadorTurnos && "c-white",
    footer: "Busca una especialidad o profesional",
    descripcion: "descripcion",
    placeholder: textosState.textos.data?.txtConsultaMedica?.descripcion,
    placeHolderFontSize: 16,
    defaultValue:
      itemBusqueda !== null && itemBusqueda !== undefined
        ? itemBusqueda.descripcion
        : 1,
    defaultValueParametro: "descripcion",
    height: 38,
    cantidadItems: 10,
    maxlength: 100,
    error: false,
    arrow: true,
    search: true,
    disabled: false,
    tooltip: false,
    showUp: true,
    regex: /^[a-zA-Z\s]+$/,
    masBuscados: configState.config.data.opcMasBuscados,
    itemBusqueda: itemBusqueda,
    buscarPorDefault: true,
  };

  return (
    <React.Fragment>
      {!buscadorTurnos && (
        <>
          <div className="ptur-buscadorConsulta-desktop-dropdown">
            <Dropdown
              valor={
                listaFamiliaresState.listaFamiliares.loading &&
                (listaFamiliaresState.listaFamiliares.data === null ||
                  listaFamiliaresState.listaFamiliares.data === "")
                  ? ""
                  : selectDropDownState.selectDropDown.selectGlobal
                      .pacienteElegido
                  ? selectDropDownState.selectDropDown.selectGlobal
                      .pacienteElegido.id
                  : authState.auth.data.paciente.codigo
              }
              datos={dropdownFamiliares(
                listaFamiliaresState,
                authState,
                "ManejoTurnos"
              )}
              campoCodigo="id"
              descripcion="nombre"
              onChange={onChangeMultitabMobile}
              placeholder={
                listaFamiliaresState.listaFamiliares.loading &&
                (listaFamiliaresState.listaFamiliares.data === null ||
                  listaFamiliaresState.listaFamiliares.data === "")
                  ? "Cargando Familiares..."
                  : ""
              }
              desactivado={
                listaFamiliaresState.listaFamiliares.loading &&
                (listaFamiliaresState.listaFamiliares.data === null ||
                  listaFamiliaresState.listaFamiliares.data === "")
                  ? true
                  : false
              }
              heightLista={"auto"}
              customCss={"widthDropdownBuscador"}
            />
            {bloqueoPresentismo && (
              <PresentismoBox
                consultas={true}
                modalInfoPresentismo={modalInfoPresentismo}
                modalTurnosPresentismo={modalTurnosPresentismo}
              />
            )}
          </div>

          {bloqueoPresentismo && (
            <div className="ptur-buscadorConsulta-presentismoMobile">
              <PresentismoBox
                consultas={true}
                modalInfoPresentismo={modalInfoPresentismo}
                modalTurnosPresentismo={modalTurnosPresentismo}
              />
            </div>
          )}
        </>
      )}

      <div
        className={
          !buscadorTurnos
            ? "cuerpoPestaniaConsulta"
            : "cuerpoPestaniaConsultaBuscadorTurnos"
        }
      >
        <div
          className={
            buscadorTurnos
              ? "ptur-buscadorConsultaTurnos-dropdown"
              : "ptur-buscadorConsulta-dropdown"
          }
        >
          <DropdownV2 config={configDropdown} onClick={onChangeBuscador} />
        </div>
        <div className="ptur-buscadorConsultaMedica-checkbox-boton">
          <div className="ptur-buscadorConsultaMedica-checkbox-container">
            {portalCem === "cemedic" ? (
              <div className="ptur-buscador-checkbox-consultaMedica-general">
                <div className="ptur-buscador-checkbox-consultaMedica">
                  <InputV1
                    inputType="hidden"
                    labelStr="Presencial"
                    labelColor={buscadorTurnos && "c-white"}
                    nombreRadio="formato"
                    name="checkpresencial"
                    onChange={onChangeRadio}
                    value={true}
                    checked
                  />
                </div>
              </div>
            ) : (
              <>
                <div className="ptur-buscador-titulo-checkbox-consultaMedica">
                  <span className={`${buscadorTurnos && "c-white"} rb14m`}>
                    Formato
                  </span>
                </div>
                <div className="ptur-buscador-checkbox-consultaMedica-general">
                  <div className="ptur-buscador-checkbox-consultaMedica">
                    <InputV1
                      inputType="radio"
                      labelStr="Presencial"
                      labelColor={buscadorTurnos && "c-white"}
                      nombreRadio="formato"
                      name="checkpresencial"
                      onChange={onChangeRadio}
                      value={true}
                      checked
                    />
                  </div>
                  <div className="ptur-buscador-checkbox-consultaMedica">
                    <InputV1
                      inputType="radio"
                      labelStr="Video llamada"
                      labelColor={buscadorTurnos && "c-white"}
                      nombreRadio="formato"
                      name="checkvideollamada"
                      onChange={onChangeRadio}
                      value={false}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="ptur-buscadorConsulta-boton-fecha">
            <div className="ptur-buscadorConsulta-fecha">
              <DatePicker
                fechaInicial={`${hoyDia.getFullYear()} ${
                  hoyDia.getMonth() + 1
                } ${hoyDia.getDate()}`}
                fechaFinal={`${noventaDiasDespues.getFullYear()} ${
                  noventaDiasDespues.getMonth() + 1
                } ${noventaDiasDespues.getDate()}`}
                headerStr={"Buscar fecha"}
                headerStrColor={buscadorTurnos && "c-white"}
                // fechaMin={hoy}
                onChange={onChangeDatePicker}
                customCss="ptur-datePciker-consultaMedica"
              />
            </div>
            <div className="ptur-buscadorConsulta-boton-container">
              <button
                onClick={() => onBuscarTurnosClick(pacienteSeleccionado)}
                className={`ptur-consulta-botonSiguiente bgc-primary c-white rb18m`}
                disabled={
                  estudioTurnosState.estudioTurnos.loading ||
                  consultaMedTurnosState.consultaMedTurnos.loading
                }
              >
                {estudioTurnosState.estudioTurnos.loading ||
                consultaMedTurnosState.consultaMedTurnos.loading ? (
                  <span className="ptur-buscadorConsulta-loading">
                    <IonSpinner name="lines-small" />
                  </span>
                ) : (
                  "Siguiente"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BuscadorConsultaMedica2;
